module.exports = __webpack_public_path__ + "static/media/clock.c6eeea91.svg";